import reportingTool from '../frontend/modules/reporting-tool';

// Wait until document fully loaded before running the reporting tool
document.addEventListener('DOMContentLoaded', () => {
  reportingTool();
});
